export const ID_TOKEN = "userID";
export const OPEN_ID = "openId";
export const USER_ID = "userId";
export const PROFILE = 'profile';
export const LOGIN_INDEX = 'loginIndex';
export const LANGUAGE = 'm_lang';

export function setIdToken(idToken) {
  localStorage.setItem(ID_TOKEN, idToken);
}

export function removeIdToken() {
  localStorage.removeItem(ID_TOKEN);
}

export function loadIdToken() {
  return localStorage.getItem(ID_TOKEN);
}

// Open Id
// export function setOpenId(openId) {
//   localStorage.setItem(OPEN_ID, openId);
// }

// export function removeOpenId() {
//   localStorage.removeItem(OPEN_ID);
// }

// export function loadOpenId() {
//   return localStorage.getItem(OPEN_ID);
// }

// Register Index
// export function setLoginIndex(loginIndex) {
//   localStorage.setItem(LOGIN_INDEX, loginIndex);
// }

// export function removeLoginIndex() {
//   localStorage.removeItem(LOGIN_INDEX);
// }

// export function loadLoginIndex() {
//   return localStorage.getItem(LOGIN_INDEX);
// }

// export function decodeUserProfile(idToken) {
//   try {
//     return idToken;
//   } catch (err) {
//     return null;
//   }
// }

// User Profile
export function loadProfile() {
  let profile = localStorage.getItem(PROFILE);
  if (profile) {
    profile = JSON.parse(profile);
  }
  return profile;
}

export function setProfile(profile) {
  if (profile) {
    localStorage.setItem(PROFILE, JSON.stringify(profile));
  }
}

export function removeProfile() {
  localStorage.removeItem(PROFILE);
}

// language
export function setLanguage(lang) {
    localStorage.setItem(LANGUAGE, lang);
  }

export function removeLanguage() {
  localStorage.removeItem(LANGUAGE);
}

export function loadLanguage() {
  return localStorage.getItem(LANGUAGE);
}
